import { types } from 'mobx-state-tree';

const PickupPoint = types.model("PickupPoint", {
  address: types.optional(types.string, ''),
  distance: types.maybeNull(types.number),
  external_info: types.optional(types.array(types.model({
    key: types.string,
    value: types.string
  })), []),
  location_info: types.maybeNull(types.string),
  name: types.optional(types.string, ''),
  opening_hours: types.maybeNull(types.string, ''),
  unique_id: types.optional(types.string, '')
});

export default PickupPoint;
